module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Git4-3fc807fce2ce0c8f4165429c2e4f2ab8.svg";